import { render } from "./overview-card-template.vue?vue&type=template&id=b426958e&let-data=true"
import script from "./overview-card-template.vue?vue&type=script&lang=js"
export * from "./overview-card-template.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__